import { colorFacetsNeutralLight700 } from '@netlify/netlify-design-tokens'
import { Strong, Tab } from 'evergreen-ui'

type Props = {
  active: boolean
  ariaLabel?: string
  disabled?: boolean
  iconAfter?: JSX.Element
  iconBefore?: JSX.Element
  id?: string
  label?: JSX.Element | string
  // name: string
  onClick?: Function
  padding?: number
  title?: string
}

export default function DockTool(props: Props) {
  const { active, ariaLabel, disabled, iconAfter, iconBefore, id, label, onClick, padding, title } = props
  return (
    <Tab
      className={active ? 'tool tool-selected' : 'tool'}
      cursor={disabled ? 'default' : 'pointer'}
      disabled={disabled}
      flexGrow={1}
      height={42} // this value needs to be reflected in quokka-loader's JAMDOCK_VIEWPORT too
      id={id}
      justifyContent="flex-start"
      margin={0}
      onSelect={onClick ? () => onClick() : undefined}
      opacity={disabled ? 0.5 : 1}
      // overflow="hidden"
      paddingX={padding ?? 16}
      pointerEvents={disabled ? 'none' : undefined}
      position="relative"
      title={title}
      transition="opacity 0.3s ease"
      whiteSpace="nowrap"
    >
      {iconBefore && iconBefore}
      {label && (
        <Strong
          aria-label={ariaLabel}
          color={colorFacetsNeutralLight700}
          // fontSize={13}
          marginLeft={iconBefore ? 8 : 0}
          marginRight={iconAfter ? 8 : 0}
        >
          {label}
        </Strong>
      )}
      {iconAfter && iconAfter}
    </Tab>
  )
}
